import React from 'react'

import { FormProvider } from 'react-hook-form'
import { ComGate } from '@sga/shopify-payments-types'

import { ActionMenu, Banner, Button, Card, Collapsible, Form, Heading, Stack, TextContainer } from '@shopify/polaris'

import { useAccount } from '../hooks/useAccount'
import { useAccountSettingsForm } from '../hooks/useAccountSettingsForm'
import { useBackToShopAction } from '../hooks/useBackToShopAction'
import { getTranslation } from '../util/getTranslation'
import { SettingsContactCard } from './SettingsContactCard'

type TProps = {
  onSuccess(): void
}

export function ComGateRegistration({ onSuccess }: TProps) {
  const {
    segmentConfig: { registrationSentAt },
  } = useAccount<ComGate.TSegmentAccount>()

  const { saveStatus, form, onSubmit } = useAccountSettingsForm((api, formValues) => api.registerComGate(formValues))

  React.useEffect(() => {
    if (registrationSentAt) {
      onSuccess()
    }
  }, [registrationSentAt, onSuccess])

  return (
    <Card sectioned title={getTranslation('comgate.registration_title')}>
      <Stack vertical>
        <Collapsible id="new" open={saveStatus === 'submit'}>
          <TextContainer>
            <p>
              {getTranslation('comgate.registration_description')}
            </p>
            <p>
              {getTranslation('comgate.existing_account_description')}
            </p>
          </TextContainer>
          <FormProvider {...form}>
            <Form onSubmit={onSubmit}>
              <SettingsContactCard emailRequired={true} />
              <Card.Section>
                <Stack distribution="trailing">
                  <Button primary submit disabled={form.formState.isSubmitting}>
                    {getTranslation('comgate.send_registration')}
                  </Button>
                </Stack>
              </Card.Section>
            </Form>
          </FormProvider>
        </Collapsible>
        <Collapsible id="done" open={saveStatus === 'success'}>
          <Stack vertical>
            <Banner status="success">
              <Heading>{getTranslation('comgate.registration_sent')}</Heading>
            </Banner>
            <TextContainer>
              <p>
                {getTranslation('comgate.registration_complete_description')}
              </p>
            </TextContainer>
            <ActionMenu actions={[useBackToShopAction()]} />
          </Stack>
        </Collapsible>
      </Stack>
    </Card>
  )
}
